import SuccessPayment from '@cannect/assets/img/home/home-v2/aprovedPayments.png'
import ProcessingPayment from '@cannect/assets/img/home/home-v2/processPayments.png'
import RefusedPayment from '@cannect/assets/img/home/home-v2/refusedPayments.png'
import React, { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

interface PaymentModalProps {
  status: 'processing' | 'success' | 'error'
  onClose: () => void
  onAction: () => void
  isAllSupplements: boolean
  isAllGeneticTests: boolean
  skipDocuments?: boolean
}

const SUCCESS_AUTO_CONTINUE_MS = 4000

const PaymentModal: React.FC<PaymentModalProps> = ({ status, onClose, onAction }) => {
  const onActionRef = useRef(onAction)
  onActionRef.current = onAction

  const content = {
    processing: {
      title: 'Processando o pagamento',
      image: ProcessingPayment,
      showButton: false,
      buttonText: undefined as string | undefined
    },
    success: {
      title: 'Pagamento Aprovado!',
      image: SuccessPayment,
      buttonText: undefined as string | undefined,
      showButton: false
    },
    error: {
      title: 'Pagamento recusado',
      image: RefusedPayment,
      buttonText: 'Revisar dados do cartão',
      showButton: true
    }
  }[status]

  useEffect(() => {
    if (status !== 'success') return

    const timer = window.setTimeout(() => {
      onActionRef.current()
    }, SUCCESS_AUTO_CONTINUE_MS)

    return () => window.clearTimeout(timer)
  }, [status])

  if (!content) return null

  const modalContent = (
    <div
      className="fixed inset-0 z-[9999999] flex h-screen w-screen items-center justify-center bg-black bg-opacity-50"
      style={{
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999999,
        position: 'fixed',
        width: '100vw',
        height: '100vh'
      }}>
      <div className="relative w-full max-w-sm rounded-xl bg-white p-6 text-center shadow-lg">
        <button
          onClick={onClose}
          className="absolute right-4 top-4 border-0 bg-transparent text-2xl text-gray-500 hover:text-gray-700">
          &times;
        </button>
        <h2 className="mb-12 text-lg font-semibold text-primary-800">{content.title}</h2>
        <img src={content.image} alt="Status do pagamento" className="mx-auto mb-12 h-[176px] w-[175px]" />
        {content.showButton && (
          <button
            onClick={onAction}
            className="w-full rounded-md border-0 bg-primary-800 px-6 py-2 font-medium text-white transition-colors hover:bg-primary-600">
            {content.buttonText}
          </button>
        )}
      </div>
    </div>
  )

  return createPortal(modalContent, document.documentElement)
}

export default PaymentModal
